// Separate token store for the Factory Tour / Blog admin panel (Sanctum-based),
// intentionally isolated from helpers/authHeader.js which manages the legacy
// system_tef_be JWT session used by /login, /account, /data-laporan, etc.
// This does NOT touch axios.defaults.headers.common so it can never leak into
// (or be overwritten by) the public site's own API calls.
const TOKEN_KEY = 'ft_admin_token'

export default {
    set(token) {
        localStorage.setItem(TOKEN_KEY, token);
    },
    unset() {
        localStorage.removeItem(TOKEN_KEY);
    },
    get() {
        return localStorage.getItem(TOKEN_KEY);
    }
}
